import { render, staticRenderFns } from "./PageBlogCategories.vue?vue&type=template&id=a8c2bd2c&"
import script from "./PageBlogCategories.vue?vue&type=script&lang=js&"
export * from "./PageBlogCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c2bd2c')) {
      api.createRecord('a8c2bd2c', component.options)
    } else {
      api.reload('a8c2bd2c', component.options)
    }
    module.hot.accept("./PageBlogCategories.vue?vue&type=template&id=a8c2bd2c&", function () {
      api.rerender('a8c2bd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blogCategories/PageBlogCategories.vue"
export default component.exports